import {
  AcquiringSettings,
  RefillStep,
  RefillTarget,
  RefillType,
} from 'app/dataTypes/acquiring/settings'

import Refill from './Refill'
import RefillSuccess from './RefillSuccess'
import RefillFail from './RefillFail'
import RefillLoading from './Refill/RefillLoading'

export type OnChangeStep = (props: {
  step: number
  target?: RefillTarget | null
  type?: RefillType | null
  targetID?: string
}) => void

type Props = {
  acquiringSettings: AcquiringSettings
  loading: boolean
  cafeteriaOwnAccountRefillDisable?: boolean // нельзя пополнять счет пользователя за столовую
  payForAlerts?: boolean //                     специальное сообщение при пополнении личного счета
  compact?: boolean //                          компактное состояние для размещения баннера слева
  showSuccess?: boolean
  showFail?: boolean
  helpPhone?: string
  refillStep: RefillStep | null //              шаг пополнения
  refillTarget: RefillTarget | null //          цель пополнения self или child
  refillType: RefillType | null //              тип пополнения cafeteria или camp
  targetID: string | null //                    id цели для пополнения, если есть
  homeURL: string
  successURL: string
  failureURL: string
  hideReplenishChild?: boolean //               скрыть пополнения детям за столовую (столовую в школе)
  hideReplenishChildCamp?: boolean //           скрыть пополнения детям за лагерь (столовую в лагере)
  onChangeStep: OnChangeStep
}

export const RefillMain = ({
  acquiringSettings,
  loading,
  cafeteriaOwnAccountRefillDisable,
  payForAlerts,
  compact,
  showSuccess,
  showFail,
  helpPhone,
  refillStep,
  refillTarget,
  refillType,
  targetID,
  homeURL,
  successURL,
  failureURL,
  hideReplenishChild,
  hideReplenishChildCamp,
  onChangeStep,
}: Props) => {
  return (
    <>
      {loading && <RefillLoading itemsCount={2} />}

      {!showSuccess && !showFail && (
        <Refill
          acquiringSettings={acquiringSettings}
          payForAlerts={payForAlerts}
          cafeteriaOwnAccountRefillDisable={cafeteriaOwnAccountRefillDisable}
          refillStep={refillStep}
          refillTarget={refillTarget}
          refillType={refillType}
          targetID={targetID}
          loading={loading}
          successURL={successURL}
          failureURL={failureURL}
          hideReplenishChild={hideReplenishChild}
          hideReplenishChildCamp={hideReplenishChildCamp}
          onChangeStep={onChangeStep}
        />
      )}

      {showSuccess && <RefillSuccess returnPath={homeURL} compact={compact} />}

      {showFail && <RefillFail phone={helpPhone} compact={compact} />}
    </>
  )
}
